import { SubsRequest } from "@/data/dtos/requests";
import { z } from "zod";

export const SubsRequestSchema: z.ZodType<SubsRequest> = z.object({
  subscription_plan_id: z.number().int().positive(),
  subscription_plan_price_id: z.number().int().positive(),
  card_id: z.string(),
  document_number: z.string().min(11),
});
